<template>
    <Dialog :value="showDialog" @input="$listeners.input" :title="'Atenção'" width="600">
        <p>
            A consulta selecionada foi atribuida como "Analisar" pelo Sistema de Crédito. Deseja realmente alterar o status de autorização para "Pendente" e solicitar uma validação biométrica ao cliente? <br>
            O motivo digitado será exibido ao usuário vendedor parceiro!
        </p>

        <m-form ref="formPendente" class="pt-4" @submit.prevent="tornarVendaPendente">
            <m-text-field ref="input"
                          label="Motivo:"
                          hint="O motivo digitado será exibido ao usuário vendedor parceiro!"
                          class="required"
                          type="text"
                          v-model="motivo"
                          placeholder="Descreva o motivo da troca do status de autorização"
                          maxlength="800"
                          outlined>
            </m-text-field>
        </m-form>
        <span class="text--darkgray">Motivo Final: *</span><br>
        {{ motivo }} {{ mensagem_fixa_biometria_mudar_para_pendente }}
        <v-layout class="justify-end">
            <v-btn color="secondary" class="mt-5 mr-4" @click="fechar()">Fechar</v-btn>
            <v-btn id="ButtonFinalizar" class="mt-5" color="primary" @click="tornarVendaPendente()">
                Confirmar
            </v-btn>
        </v-layout>
    </Dialog>
</template>

<script>

  import { AlertTypes } from '../../../../plugins/alerts_types'
  import { mensagem_fixa_biometria_mudar_para_pendente } from '../../../../plugins/constants/analise_credito'
  import { notification } from '../../../../plugins/helpers'
  export default {
    name: 'DialogMudarParaPendente',
    props: {
      value: Boolean,
      consulta: Object
    },
    data () {
      return {
        mensagem_fixa_biometria_mudar_para_pendente,
        motivo: ''
      }
    },
    computed: {
      showDialog: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    watch: {
      showDialog () {
        this.$refs.formPendente.resetValidation()
        this.motivo = ''
      }
    },
    methods: {
      fechar () {
        this.showDialog = false
      },
      async tornarVendaPendente () {
        const form = this.$refs.formPendente
        if (form.validate()) {
          const motivo = `${this.motivo} ${mensagem_fixa_biometria_mudar_para_pendente}`
          await this.$http.post('painel/tornar-pendente/credito-analise', { id_consulta: this.consulta.id_consulta, motivo }).then(res => {
            notification(AlertTypes.INFO, 'Venda alterada para pendente. Aguardando validação biométrica pela análise cadastral.')
          })
            .catch(() => {
              this.$refs.formPendente.resetValidation()
              notification(AlertTypes.ERROR, 'Erro ao colocar a venda pendente!')
            })
          this.reload()
        }
      },
      reload () {
        this.$emit('reload')
        this.fechar()
        return true
      }
    }
  }
</script>

<style scoped>

</style>
